// extracted by mini-css-extract-plugin
export default {"wrapper":"startViev_wrapper__Fb5tG","image":"startViev_image__C+P2-","special":"startViev_special__+xbjL","inside":"startViev_inside__r5UVO","bigInfo":"startViev_bigInfo__z+tyV"};